export const formatPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\D+/g, "").slice(0, 11);
  let formattedNumber = "";

  if (cleaned.startsWith("02")) {
    if (cleaned.length <= 2) {
      formattedNumber = cleaned;
    } else if (cleaned.length <= 5) {
      formattedNumber = `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`;
    } else if (cleaned.length <= 9) {
      formattedNumber = `${cleaned.slice(0, 2)}-${cleaned.slice(2, cleaned.length - 4)}-${cleaned.slice(-4)}`;
    } else {
      formattedNumber = `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    }
  } else if (cleaned.startsWith("1")) {
    formattedNumber = cleaned;
  } else {
    if (cleaned.length <= 3) {
      formattedNumber = cleaned;
    } else if (cleaned.length <= 6) {
      formattedNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    } else if (cleaned.length <= 10) {
      formattedNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3, cleaned.length - 4)}-${cleaned.slice(-4)}`;
    } else {
      formattedNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
    }
  }

  return formattedNumber;
};

export const toHHmmss = (dateObj) => {
  if (!dateObj) return '';
  const hh = String(dateObj.getHours()).padStart(2, '0');
  const mm = String(dateObj.getMinutes()).padStart(2, '0');
  return `${hh}${mm}00`; 
};

export const toDateObj = (hhmmss) => {
  if (!hhmmss) return null;
  const h = parseInt(hhmmss.slice(0, 2), 10);
  const m = parseInt(hhmmss.slice(2, 4), 10);
  return new Date(0, 0, 0, h, m);
};